import React from "react"
import { injectIntl } from "react-intl"

import {
    DOCUMENT_TYPE_TEMPLATE_TAB_MESSAGES,
} from "../../../../utils/inventory"
import StandardList from "../../../../common/listing/list.component"
import IntlProps from "../../../../state/helpers/IntlProps"
import { useSelector } from "react-redux"
import { InventoryStockDocumentDefinitionSelector } from "../../../../state/inventory"
import { BasicRow } from "../../../../common/listing/ListingTypes"
import { Link } from "react-router-dom"
import Icon from "../../../../common/icon/icon.component"

export const Template = injectIntl((props: IntlProps) => {
    const templates = useSelector(InventoryStockDocumentDefinitionSelector.getTemplates)
    const includeContact = useSelector(InventoryStockDocumentDefinitionSelector.getIncludeContact)
    const documentRows: Array<BasicRow> = templates.documentTemplates.map(template => {
        return {
            rowId: template.id,
            data: [
                <Link key={template.id} to={`/templates/${template.id}/sections/preview`}>
                    <Icon value={"pencil-ruler"} className={"mr-1"}/>
                    {props.intl.formatMessage(DOCUMENT_TYPE_TEMPLATE_TAB_MESSAGES["documentTemplate"])}
                    <Icon value={"chevron-right"}/>
                </Link>,
            ]
        }
    })

    const emailRows: Array<BasicRow> = templates.emailTemplates.map(template => {
        return {
            rowId: template.id,
            data: [
                <Link key={template.id} to={`/settings/editEmailTemplatesById/${template.id}`}>
                    <Icon value={"envelope"} className={"mr-1"}/>
                    {props.intl.formatMessage(DOCUMENT_TYPE_TEMPLATE_TAB_MESSAGES["emailTemplate"])}
                    <Icon value={"chevron-right"}/>
                </Link>,
            ]
        }
    })



    return (
        <div className="col-12 mt-2">

            <small className="form-text text-muted">
                {props.intl.formatMessage(DOCUMENT_TYPE_TEMPLATE_TAB_MESSAGES["description"])}
            </small>

            <StandardList
                className="pl-0"
                rows={documentRows}
            />

            {includeContact &&
                <StandardList
                    className="pl-0"
                    rows={emailRows}
                />
            }
        </div>
    )
})


// WEBPACK FOOTER //
// ./src/inventory/sections/documentTypes/tabs/Template.tsx